import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPersonFill = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M480-480q-66 0-113-47t-47-113 47-113 113-47 113 47 47 113-47 113-113 47M240-160q-33 0-56.5-23.5T160-240v-32q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440t130 15.5T736-378q29 15 46.5 43.5T800-272v32q0 33-23.5 56.5T720-160z" })));
const ForwardRef = forwardRef(SvgPersonFill);
const Memo = memo(ForwardRef);
export default Memo;
